"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProcessWorklease = exports.EvaluateWorklease = exports.StatusIterable = exports.RefreshSourceSchema = exports.RefreshSourceIterable = exports.RefreshConfig = exports.DataConfig = void 0;
const zod_1 = require("zod");
var DataConfig;
(function (DataConfig) {
    // *** SCHEMA ***
    DataConfig.SchemaItemTypeIterable = [
        'string',
        'number',
        'boolean',
    ];
    DataConfig.SchemaItemTypeSchema = zod_1.z.enum(DataConfig.SchemaItemTypeIterable);
    DataConfig.SchemaItemSchema = zod_1.z.object({
        columnName: zod_1.z.string(),
        type: DataConfig.SchemaItemTypeSchema,
    });
    // *** DATA ACCESSOR ***
    DataConfig.AccessorTypeIterable = ['athena'];
    DataConfig.AccessorTypeSchema = zod_1.z.enum(DataConfig.AccessorTypeIterable);
    DataConfig.AthenaAccessorConfigSchema = zod_1.z.object({
        queryString: zod_1.z.string(),
    });
    DataConfig.AthenaDataAccessorSchema = zod_1.z.object({
        name: zod_1.z.string(),
        type: zod_1.z.literal('athena'),
        config: DataConfig.AthenaAccessorConfigSchema,
    });
    DataConfig.DataAccessorSchema = DataConfig.AthenaDataAccessorSchema;
    DataConfig.ConfigSchema = zod_1.z.object({
        schema: zod_1.z.array(DataConfig.SchemaItemSchema),
        /**
         * Setting this as an array for future use cases where we may want to support
         * aggregating multiple data sources (e.g., other PG data) and potentially
         * applying some business logic to them (JOIN, SUM, etc.). This array will be
         * evaluated sequentially to determine how data is queried and transformed
         */
        dataAccessors: zod_1.z.array(DataConfig.DataAccessorSchema),
    });
})(DataConfig || (exports.DataConfig = DataConfig = {}));
var RefreshConfig;
(function (RefreshConfig) {
    // @MV TODO: update below structure
    RefreshConfig.ConfigSchema = zod_1.z.object({});
})(RefreshConfig || (exports.RefreshConfig = RefreshConfig = {}));
exports.RefreshSourceIterable = ['glueCompletion', 'manual'];
exports.RefreshSourceSchema = zod_1.z.enum(exports.RefreshSourceIterable);
exports.StatusIterable = [
    'initializedConfig', // Created config for materialized view
    'initializedTable', // Created MV table but haven't populated with data
    'refreshInProgress',
    'refreshComplete',
    'deleted',
    'errorCreateTable',
    'errorRefreshData',
    'errorDeleteTableAndConfig',
];
// ************************************************
//              EVALUATE WORKLEASE SETUP
// ************************************************
var EvaluateWorklease;
(function (EvaluateWorklease) {
    const WorkleaseTypeIterable = ['create', 'refresh', 'delete'];
    EvaluateWorklease.WorkleaseTypeSchema = zod_1.z.enum(WorkleaseTypeIterable);
    EvaluateWorklease.RefreshConfigSchema = zod_1.z.object({
        refreshSource: exports.RefreshSourceSchema,
    });
    EvaluateWorklease.CreateWorkleaseSchema = zod_1.z.object({
        materializedViewConfigId: zod_1.z.string(),
        type: zod_1.z.literal('create'),
        config: zod_1.z.null(),
    });
    EvaluateWorklease.RefreshWorkleaseSchema = zod_1.z.object({
        materializedViewConfigId: zod_1.z.string(),
        type: zod_1.z.literal('refresh'),
        config: EvaluateWorklease.RefreshConfigSchema,
    });
    EvaluateWorklease.DeleteWorkleaseSchema = zod_1.z.object({
        materializedViewConfigId: zod_1.z.string(),
        type: zod_1.z.literal('delete'),
        config: zod_1.z.null(),
    });
    EvaluateWorklease.OptionsSchema = zod_1.z.union([
        EvaluateWorklease.CreateWorkleaseSchema,
        EvaluateWorklease.RefreshWorkleaseSchema,
        EvaluateWorklease.DeleteWorkleaseSchema,
    ]);
})(EvaluateWorklease || (exports.EvaluateWorklease = EvaluateWorklease = {}));
// ************************************************
//               PROCESS WORKLEASE SETUP
// ************************************************
// NOTE: at the moment, this is the same set up as the "Evaluate" worklease
// above. Separated these two into their own in case they need to be different
// and some transformation process is done between them, as different lambdas
// process these workleases. If they continually stay the same and becomes onerous
// in managing two of the same instances, can consider consolidating them
var ProcessWorklease;
(function (ProcessWorklease) {
    const WorkleaseTypeIterable = ['create', 'refresh', 'delete'];
    ProcessWorklease.WorkleaseTypeSchema = zod_1.z.enum(WorkleaseTypeIterable);
    ProcessWorklease.RefreshConfigSchema = zod_1.z.object({
        refreshSource: exports.RefreshSourceSchema,
    });
    ProcessWorklease.CreateWorkleaseSchema = zod_1.z.object({
        materializedViewConfigId: zod_1.z.string(),
        type: zod_1.z.literal('create'),
        config: zod_1.z.null(),
    });
    ProcessWorklease.RefreshWorkleaseSchema = zod_1.z.object({
        materializedViewConfigId: zod_1.z.string(),
        type: zod_1.z.literal('refresh'),
        config: ProcessWorklease.RefreshConfigSchema,
    });
    ProcessWorklease.DeleteWorkleaseSchema = zod_1.z.object({
        materializedViewConfigId: zod_1.z.string(),
        type: zod_1.z.literal('delete'),
        config: zod_1.z.null(),
    });
    ProcessWorklease.OptionsSchema = zod_1.z.union([
        ProcessWorklease.CreateWorkleaseSchema,
        ProcessWorklease.RefreshWorkleaseSchema,
        ProcessWorklease.DeleteWorkleaseSchema,
    ]);
})(ProcessWorklease || (exports.ProcessWorklease = ProcessWorklease = {}));
//# sourceMappingURL=MaterializedView.js.map